import React from "react";
import PublicLeagueSubmitted from "./PublicLeagueSubmitted";

// Route entry for /contest/public-league-created — the fifth and last screen of
// the public flow.
//
// It no longer shares a component with the private hand-off. Client Rev 1: the
// old shared design "was flawed for its approval state" — a public league is
// submitted for review rather than created, and it hands over neither an invite
// code nor a share link while it is pending. See PublicLeagueSubmitted.
// LeagueCreatedSuccess remains the private flow's payoff.
const PublicLeagueCreatedSuccess = () => <PublicLeagueSubmitted />;

export default PublicLeagueCreatedSuccess;
